import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Wrapper from "../components/Wrapper";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { did, included, input, menu, sip } from "../translate";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import TableBody from "@mui/material/TableBody";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import AddAndEditDidNumbers from "../components/AddAndEditDidNumbers";
import { didDelete, didDeleteLocal, didRequest } from "../store/actions/did";
import _ from 'lodash';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import Api from "../Api";
import SingleDidNumbers from "../components/SingleDidNumbers";
import Utils from "../Utils";
import TablePagination from "@mui/material/TablePagination";
import Cookies from "js-cookie";

const titleArr = [
    sip.phone[+localStorage.getItem('atsLang')  || 1],
    sip.forward[+localStorage.getItem('atsLang')  || 1],
    sip.note[+localStorage.getItem('atsLang')  || 1],
    did.active[+localStorage.getItem('atsLang')  || 1],
    did.date[+localStorage.getItem('atsLang')  || 1],
    did.line[+localStorage.getItem('atsLang')  || 1],
    did.no_line[+localStorage.getItem('atsLang')  || 1],
];
let descArr = []
const {REACT_APP_SERVER} = process.env;
let color = REACT_APP_SERVER === 'ATS'?'#0973b9':'#7ebc0a'
const defaultRowsPerPage = Number(Cookies.get('did')) || 10;

function DidNumbers(props) {
    const didData = useSelector(state => state.did.didData)
    const didStatus = useSelector(state => state.did.didStatus)
    const [edit, setEdit] = useState(0)
    const [create, setCreate] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [copied, setCopied] = useState(false)
    const [single, setSingle] = useState(0)
    const [searchText, setSearchText] = useState('')
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage === -1 ? 10 : defaultRowsPerPage)
    const dispatch = useDispatch()
    const profile = useSelector(state => state.users.ursData)

    useEffect(() => {
        dispatch(didRequest('', 99999, 1))
    }, [dispatch])

    const handleDelete = useCallback(async (id, profile, username, provider) => {
        try {
            let text = +localStorage.getItem('atsLang') === 1 ? "Are you sure you want to delete?" :
                +localStorage.getItem('atsLang') === 2 ? "Вы уверены, что хотите судалить?" :
                    "Վստա՞հ եք, որ ցանկանում եք ջնջել";
            if (confirm(text) === true) {
                if (+profile === 45 && username) {
                    await Api.telegRegDelete(username)
                }
                await dispatch(didDeleteLocal(id, provider))
                await dispatch(didDelete(id, provider))
            }
        } catch (e) {
            console.log(e)
        }
    }, [dispatch])

    const handleSearch = useCallback((ev) => {
        setSearchText(ev.target.value)
        setPage(0)
    }, [])

    const handleChangePage = useCallback((event, newPage) => {
        setPage(newPage)
    }, [])

    const handleRowsPerPageChange = useCallback((ev) => {
        const newLimit = Number(ev.target.value)
        setRowsPerPage(newLimit)
        if (newLimit !== -1) Cookies.set('did', String(newLimit), { expires: 30 })
        setPage(0)
    }, [])

    const filteredData = useMemo(() => {
        if (!Array.isArray(didData)) return []
        const q = (searchText || '').toLowerCase().trim()
        if (!q) return didData
        return didData.filter(s => {
            const phone = (s.pref || '') + (s.did || '')
            const forward = (s?.output?.output ?? '') + ''
            const notes = (s.notes ?? '') + ''
            const line = (s.dlines ?? '') + ''
            const nodline = (s.nodline ?? '') + ''
            const active = `${s.in || ''} - ${s.out || ''}`
            const date = `${s.inTimeT ? Utils.secToHours(s.inTimeT) : ''} - ${s.outTimeT ? Utils.secToHours(s.outTimeT) : ''}`
            return [phone, forward, notes, line, nodline, active, date].some(str =>
                String(str).toLowerCase().includes(q))
        })
    }, [didData, searchText])

    const dlinesSum = useMemo(() => {
        return filteredData.reduce((acc, s) => acc + (Number(s.dlines) || 0), 0)
    }, [filteredData])

    const paginatedData = useMemo(() => {
        if (rowsPerPage === -1) return filteredData
        const start = page * rowsPerPage
        return filteredData.slice(start, start + rowsPerPage)
    }, [filteredData, page, rowsPerPage])

    const descArr = useMemo(() => {
        return filteredData.map(s => ({
            phone: s.pref + s.did,
            forward: s?.output?.output,
            note: s.notes,
            active: `${s.in} - ${s.out}`,
            date: `${s.inTimeT ? Utils.secToHours(s.inTimeT) : ''} - ${s.outTimeT ? Utils.secToHours(s.outTimeT) : ''}`,
            line: s.dlines,
            no_line: s.nodline
        }))
    }, [filteredData])
    return (
        <>
            <Helmet>
                <title>
                    {menu.did[+localStorage.getItem('atsLang')  || 1]}
                </title>
            </Helmet>
            <Wrapper>
                <div className="tableParent">
                    <Paper sx={{minWidth: 'fit-content', fontSize: 10}}>
                        <TableContainer
                        >
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow className="sip_header">
                                        <TableCell sx={{fontSize: 20,}} align="left" colSpan={5}>
                                            {did.did[+localStorage.getItem('atsLang')  || 1]}
                                        </TableCell>
                                        <TableCell sx={{fontSize: 15, padding: '0 35px',}} align="right" colSpan={6}>
                                            <span className="d-flex justify-content-end align-items-center">
                                                <label className="search">
                                                    <input
                                                        value={searchText}
                                                        onChange={handleSearch}
                                                        placeholder={input.search[+localStorage.getItem('atsLang')  || 1]}/>
                                                    <span className="search_cover" style={isSearch ? {top: 0} : {}}/>
                                                </label>
                                                <span style={{margin: '0 10px'}} className="add"
                                                      onClick={() => setIsSearch(!isSearch)}>
                                                <SearchIcon/>
                                                </span>
                                                <span className="add" onClick={() => setCreate(true)}>
                                                <AddCircleOutlineIcon/>
                                            </span>
                                            </span>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow className="sip_num">
                                        <TableCell
                                            align='center'
                                        />
                                        <TableCell
                                            align='center'
                                        >
                                            {sip.phone[+localStorage.getItem('atsLang')  || 1]}
                                        </TableCell>
                                        <TableCell
                                            align='center'
                                        >
                                            {sip.forward[+localStorage.getItem('atsLang')  || 1]}
                                        </TableCell>
                                        <TableCell
                                            align='center'
                                        >
                                            {sip.note[+localStorage.getItem('atsLang')  || 1]}

                                        </TableCell>
                                        <TableCell
                                            align='center'
                                        >
                                            {did.active[+localStorage.getItem('atsLang')  || 1]}
                                        </TableCell>
                                        <TableCell
                                            align='center'
                                        >
                                            {did.date[+localStorage.getItem('atsLang')  || 1]}
                                        </TableCell>
                                        <TableCell
                                            align='center'
                                        >
                                            {did.line[+localStorage.getItem('atsLang')  || 1]}
                                        </TableCell>
                                        <TableCell
                                            align='center'
                                        >
                                            {did.no_line[+localStorage.getItem('atsLang')  || 1]}
                                        </TableCell>
                                        <TableCell
                                            align='center'
                                        >
                                            {sip.action[+localStorage.getItem('atsLang')  || 1]}
                                        </TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {didStatus === 'request' ? (
                                        <TableRow hover role="checkbox" tabIndex={-1}>
                                            <TableCell align="center" colSpan={12} sx={{fontSize: 13}}>
                                                Loading...
                                            </TableCell>
                                        </TableRow>
                                    ) : didStatus === 'success' && !paginatedData.length ? (
                                        <TableRow hover role="checkbox" tabIndex={-1}>
                                            <TableCell align="center" colSpan={12} sx={{fontSize: 13}}>
                                                {searchText ? 'no matching data' : 'no data'}
                                            </TableCell>
                                        </TableRow>
                                    ) : paginatedData.map(s => (
                                                <TableRow key={s.pref + s.did+s.provider} hover role="checkbox" tabIndex={-1}>
                                                    <TableCell align="center">
                                                        {s.redirect?.st === 10 || (!s.redirect && s.ord > 0) ?
                                                            <CheckCircleIcon style={{color:color,fontSize:18,marginLeft:10}}/> : null}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {s.pref + s.did}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {s?.output?.output}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {s.notes}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {s.in} - {s.out}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {s.inTimeT?Utils.secToHours(s.inTimeT):''} - {s.outTimeT?Utils.secToHours(s.outTimeT):''}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {s.dlines}
                                                    </TableCell>
                                                    <TableCell align="center" sx={{color: 'red'}}>
                                                        {+s.nodline || ''}

                                                    </TableCell>

                                                    <TableCell align="center" className="action">
                                                        <p style={{display: "flex", justifyContent: 'center'}}>
                                                    <span onClick={() => setSingle(s.pref + s.did + '_' + s.provider)}
                                                          className="edit"><FontAwesomeIcon
                                                        icon={faEye}/></span>
                                                            <span onClick={() => setEdit(s.pref + s.did + '_' + s.provider)}
                                                                  className="edit"><FontAwesomeIcon
                                                                icon={faPenToSquare}/></span>
                                                            {!_.isEmpty(profile) || s.provider === 4?
                                                                <span
                                                                    onClick={() => handleDelete(s.pref + s.did, s.redirect?.provider, s.redirect?.username,s.provider)}
                                                                    className="delete"><FontAwesomeIcon
                                                                    icon={faTrashCan}/></span> : null}
                                                        </p>
                                                    </TableCell>

                                                </TableRow>

                                            ))
                                    }
                                    <TableRow>
                                        <TableCell align="center" colSpan={3}>
                                            {did.line[+localStorage.getItem('atsLang')  || 1]}
                                        </TableCell>
                                        <TableCell align="center" colSpan={6}>
                                            {dlinesSum}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="foot_footer d-flex align-items-center justify-content-end">
                            <Link style={{margin: '0 10px'}} onClick={() => Utils.dataToExel(titleArr, descArr)}>Excel</Link>
                            <Link style={{margin: '0 10px'}} onClick={() => window.print()}>Print</Link>
                            <Link style={{margin: '0 10px'}} onClick={() => Utils.dataToExel(titleArr, descArr)}>CSV</Link>
                            <Link style={{margin: '0 10px'}} onClick={() => Utils.copy(setCopied)}>COPY</Link>
                            <TablePagination
                                className="hello"
                                rowsPerPageOptions={[10, 25, 100, { label: 'All', value: -1 }]}
                                component="div"
                                count={filteredData.length}
                                rowsPerPage={rowsPerPage === -1 ? Math.max(filteredData.length, 1) : rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleRowsPerPageChange}
                            />
                        </div>
                        {copied ? <div className="copied">Copied</div> : null}
                    </Paper>

                </div>
                {create ? <AddAndEditDidNumbers open={create} edit={false} setOpen={setCreate}/> : null}
                {single ? <SingleDidNumbers open={single} edit={single} setOpen={setSingle}/> : null}
                {edit ? <AddAndEditDidNumbers open={edit} edit={edit} setOpen={setEdit}/> : null}
            </Wrapper>
        </>

    );
}

export default DidNumbers;
